/* eslint-disable react/prop-types */
import { Select } from "@mui/material";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import SoftBox from "../../components/SoftBox";
import SoftInput from "../../components/SoftInput";
import SoftTypography from "../../components/SoftTypography";
import SoftButton from "components/SoftButton";
import queryString from "utils/queryString";
import { toast } from "react-toastify";
import { useState } from "react";
import React from "react";
import { getGhollaks } from "services/ghollak.routes";
import { getInvestmentOpportunity } from "services/investmentOpportunity.routes";

export default function TableHeadItems({ filterInfo, onClearFilterClick, handleFilterChange, onFilterClick }) {
    const [ghollakResults, setGhollakResults] = useState([]);
    const [investmentResults, setInvestmentResults] = useState([]);
    const [searchInfo, setSearchInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setSearchInfo({ ...searchInfo, [name]: value });
    };

    const searchGhollaks = () => {
        if (searchInfo.ghollakName) {
            setLoading(true);
            let query = {
                admin: 1,
                name: searchInfo.ghollakName,
                all: 1,
                per_page: 30,
            };

            getGhollaks(queryString(query), true, (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message);
                } else {
                    setGhollakResults(data.data);
                }
            });
        }
    };
    const searchInvestment = () => {
        if (searchInfo.IOName) {
            setLoading(true);
            let query = {
                name: searchInfo.IOName,
                per_page: 30,
            };

            getInvestmentOpportunity(queryString(query), true, (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message);
                } else {
                    setInvestmentResults(data.data);
                }
            });
        }
    };
    return (
        <Grid container gap={2} mb={2}>
            <Grid item xs={12} md={6} lg={2}>
                <SoftBox mb={1} ml={0.5}>
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                        قلک
                    </SoftTypography>
                </SoftBox>
                <SoftInput
                    placeholder="نام قلک"
                    value={searchInfo?.ghollakName}
                    name="ghollakName"
                    onChange={handleChange}
                    type="text"
                    endAdornment={
                        <SoftButton
                            onClick={searchGhollaks}
                            size="small"
                            style={{ position: "absolute", left: '-1rem' }}
                            variant="text"
                            disabled={loading}
                            color="info"
                        >
                            {loading ? "..." : "🔍"}
                        </SoftButton>
                    }
                />
                {ghollakResults.length > 0 && <section>
                    <p style={{ fontSize: 12, marginTop: 10 }}>قلک ها</p>
                    <Select
                        name="ghollak_id"
                        defaultOpen
                        value={String(filterInfo?.ghollak_id)}
                        onChange={handleFilterChange}
                        fullWidth
                    >
                        <MenuItem value="">
                            <em>هیچکدام</em>
                        </MenuItem>
                        {ghollakResults.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </section>}
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
                <SoftBox mb={1} ml={0.5}>
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                        فرصت
                    </SoftTypography>
                </SoftBox>
                <SoftInput
                    placeholder="نام فرصت"
                    value={searchInfo?.IOName}
                    name="IOName"
                    onChange={handleChange}
                    type="text"
                    endAdornment={
                        <SoftButton
                            onClick={searchInvestment}
                            size="small"
                            style={{ position: "absolute", left: '-1rem' }}
                            variant="text"
                            disabled={loading}
                            color="info"
                        >
                            {loading ? "..." : "🔍"}
                        </SoftButton>
                    }
                />
                {investmentResults.length > 0 && <section>
                    <p style={{ fontSize: 12, marginTop: 10 }}>فرصت ها</p>
                    <Select
                        name="investment_opportunity_id"
                        defaultOpen
                        value={String(filterInfo?.investment_opportunity_id)}
                        onChange={handleFilterChange}
                        fullWidth
                    >
                        <MenuItem value="">
                            <em>هیچکدام</em>
                        </MenuItem>
                        {investmentResults.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </section>}
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <SoftButton
                    onClick={onFilterClick}
                    size="small"
                    style={{ marginTop: 40, width: 100 }}
                    variant="gradient"
                    color="info"
                >
                    فیلتر
                </SoftButton>
                <SoftButton
                    onClick={() => {
                        setGhollakResults([]);
                        setSearchInfo({});
                        setInvestmentResults([]);
                        onClearFilterClick();
                    }}
                    size="small"
                    style={{ marginTop: 40, marginRight: 10, width: 44 }}
                    variant="outlined"
                    color="error"
                >
                    حذف
                </SoftButton>
            </Grid>
        </Grid>
    );
}
